import { inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Location } from '@angular/common';
import { AuthService } from '../services/auth.service';
import { PermissionService } from '../services/permission.service';
import { RoutePermissionService } from '../services/route-permission.service';

export const AuthGuard = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const location = inject(Location);
  const permissionService = inject(PermissionService);
  const routePermissionService = inject(RoutePermissionService);

  const isAuthenticated = authService.isAuthenticated();

  if (isAuthenticated) {
    // Use the route being activated instead of current URL
    const targetUrl = state.url;

    // Check permissions for the target route
    const requiredPermissions = routePermissionService.getRequiredPermissions(targetUrl);

    if (requiredPermissions.length > 0) {
      // Check if user has any of the required permissions
      const hasPermission = permissionService.hasAnyPermissionSync(requiredPermissions);

      if (!hasPermission) {
        // If no permission found, prevent navigation and stay on current page
        console.warn(`Access denied to ${targetUrl}. Required permissions:`, requiredPermissions);

        // Show user-friendly message (optional - can be replaced with toast/notification)

        // Show browser alert as a simple notification
        // TODO: Replace with toast notification service when available
        // Example: this.notificationService.showError(`Access Denied: ${permissionNames.join(', ')}`);

        // Navigate back to the previous page to prevent redirect to root
        // This ensures the user stays on their current page instead of being redirected to /

        // Use browser history to go back to the previous page
        // This prevents the infinite loop since we're going back to the actual previous page
        window.history.back();

        // Return false to prevent navigation to the target route
        return false;
      }
    }

    return true;
  } else {
    router.navigate(['/login']);
    return false;
  }
};
